// extracted by mini-css-extract-plugin
export var calendarView = "_os-0";